import { render, staticRenderFns } from "./CardContent.vue?vue&type=template&id=206cf14c&scoped=true"
import script from "./CardContent.vue?vue&type=script&lang=ts"
export * from "./CardContent.vue?vue&type=script&lang=ts"
import style0 from "./CardContent.vue?vue&type=style&index=0&id=206cf14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cf14c",
  null
  
)

export default component.exports